module.exports = __webpack_public_path__ + "static/fonts/MarkBlack-Italic.d6ebf87.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/MarkBlack-Italic.otf
// module id = 856
// module chunks = 320